module.exports = __webpack_public_path__ + "d67a38693313ab2e78b96b5218be99b2.png";